export const GET_IGNORE_COMMENTS = 'GET_IGNORE_COMMENTS';
export const SET_IGNORE_COMMENTS = 'SET_IGNORE_COMMENTS';
export const API_ERROR = 'LOGIN_API_ERROR';
export const SET_IGNORE_COMMENT = 'SET_IGNORE_COMMENT';
export const ADD_IGNORE_COMMENT = 'ADD_IGNORE_COMMENT';
export const EMPTY_IGNORE_COMMENT = 'EMPTY_IGNORE_COMMENT';
export const DELETE_IGNORE_COMMENT = 'DELETE_IGNORE_COMMENT';
export const EDIT_IGNORE_COMMENT = 'EDIT_IGNORE_COMMENT';
export const UPDATE_IGNORE_COMMENT = 'UPDATE_IGNORE_COMMENT';
export const SET_IGNORE_COMMENT_FILTER = 'SET_IGNORE_COMMENT_FILTER';
export const GET_IGNORE_COMMENTS_LIST = 'GET_IGNORE_COMMENTS_LIST';
export const SET_IGNORE_COMMENTS_LIST = 'SET_IGNORE_COMMENTS_LIST';